var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15 0C7.84624 0 7.6 0.23359 7.6 0.521739V2.18182C3.95492 2.18182 1 4.98491 1 8.44269V17.7391C1 21.1969 3.95492 24 7.6 24H16.4C20.0451 24 23 21.1969 23 17.7391V8.44269C23 4.98491 20.0451 2.18182 16.4 2.18182V0.521739C16.4 0.233591 16.1538 0 15.85 0C15.5462 0 15.3 0.23359 15.3 0.521739V2.18182H8.7V0.521739C8.7 0.233591 8.45376 0 8.15 0ZM7.6 3.2253C4.56243 3.2253 2.1 5.5612 2.1 8.44269V8.72727H21.9V8.44269C21.9 5.5612 19.4376 3.2253 16.4 3.2253V5.73913C16.4 6.02728 16.1538 6.26087 15.85 6.26087C15.5462 6.26087 15.3 6.02728 15.3 5.73913V3.2253H8.7V5.73913C8.7 6.02728 8.45376 6.26087 8.15 6.26087C7.84624 6.26087 7.6 6.02728 7.6 5.73913V3.2253ZM2.1 9.81818H21.9V17.7391C21.9 20.6206 19.4376 22.9565 16.4 22.9565H7.6C4.56243 22.9565 2.1 20.6206 2.1 17.7391V9.81818Z",
    fill: "currentColor",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabCalendar);
export default __webpack_public_path__ + "static/media/tab_calendar.ff15d534.svg";
export { ForwardRef as ReactComponent };